<template>
  <div class="col-lg-8 offset-lg-2 page" ref="procedure-page">

    <div class="row form-container">
      
      <!-- filter -->
      <filter-procedures v-on:filter-procedures="updateFilterResult"
                         v-on:update-keywords="updateKeywords"
                         :type="type"
                         :arrayToFilter="allProcedures">
      </filter-procedures>

      <!-- sort -->
      <sort-procedures v-on:sortArray="updateSortResult"
                       :arrayToSort="filteredProcedures">
      </sort-procedures>

    </div>

    <ul class="list-group">
      
      <small class="mb-md-2 md-2 mb-md-3 mb-3"><font-awesome-icon icon="plus-circle" class="mr-md-1 mr-1" /> ADD TO WATCH LIST</small>

      <li v-for="(procedure, index) in filteredProcedures"
          v-bind:key="procedure.id"
          class="list-group-item">
*** {{procedure.npi}}
        <!-- button to add to watch list -->
        <watch-button-procedure :procCcd="procedure.ccd" :procId="procedure.id"></watch-button-procedure>

        <div class="card">
          <!-- accordion header: procedures -->
          <procedure-header :procedure="procedure"
                            :keywords="keywords"
                            :index="index">
          </procedure-header>

          <!-- accordion body: measurements -->
          <procedure-body :procedure="procedure"
                          :keywords="keywords"
                          :index="index">
          </procedure-body>
          <!-- <router-link v-if="procedure.npi" :to="'/'procedure.npi"> -->
          <router-link v-if="procedure.npi" :to="{ name: 'ProviderNavigation', params: { specialty: getSpecialtyLink(getProviderSpecialtiesByNpi(allData, procedure.npi)), id: procedure.npi } }">
            Provider - {{ procedure.npi }}
          </router-link>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SortProcedures from '../_partials/sort/SortPage';
import FilterProcedures from '../_partials/filter/FilterPage';
import ProcedureHeader from './ProcedureHeader';
import ProcedureBody from './ProcedureBody';
import WatchButtonProcedure from '../_partials/watch/WatchButtonProcedure';
import {
  getProviderSpecialtiesByNpi
} from '@/api/getters/provider';

export default {
  name: "procedures-page",
  data() {
    return {
      allProcedures: [],                             // stores procedures from the vuex state
      filteredProcedures: [],                     // stores the filtered results
      keywords: [],
      loader: null,
      type: 'PROCEDURE',
    }
  },
  components: {
    'sort-procedures': SortProcedures,
    'filter-procedures': FilterProcedures,
    'procedure-header': ProcedureHeader,
    'procedure-body': ProcedureBody,
    'watch-button-procedure': WatchButtonProcedure
  },

  created: function () {
    // this.allData = this.$store.getters['login/getAllData']
  },
  beforeMount() {
    this.loader = this.$loading.show();
    this.filteredProcedures = this.allProcedures = this.getProcedures();
  },
  mounted() {
    this.loader.hide();
    this.loader = null;
  },
  beforeDestroy() {
    // clean up
    this.allProcedures = null;
    delete this.allProcedures;
    this.filteredProcedures = null;
    delete this.filteredProcedures;
    this.keywords = null;
    delete this.keywords;
    this.loader = null;
    delete this.loader;
  },
  computed: {
    ...mapGetters('login', {
      allData: 'getAllData'
    }),
    getProviderSpecialtiesByNpi
  },
  methods: {
    /* updated sorted result */
    updateSortResult(payload) {
      this.filteredProcedures = payload;
    },

    /* update filtered result */
    updateFilterResult(payload) {
      this.filteredProcedures = payload;
    },

    /* update keywords highlight */
    updateKeywords(payload) {
      this.keywords = payload;
    },

    /**
     * Get procedures and its measures
     * This function should be called only once upon component creation,
     * subsequent usage of procedures should make calls to the `procedures` instance
     * @returns {Array}
     */
    getProcedures() {
      let procedures = [];

      let keys = Object.keys(this.allData.procedures);
      for (let i = 0, length = keys.length; i < length; i++) {
        let procedure = this.allData.procedures[keys[i]];
        procedures[i] = {
          id: procedure.id,
          ccd: procedure.ccd,
          npi: procedure.npi,
          lodate: procedure.lodate,
        }
      }

      return _.orderBy(procedures, [( element ) => { return element.lodate || ''}], 'desc');
    },

  }
}
</script>

<style scoped lang="scss">
  .page {
    max-width: 800px;
  }

  /* overwrite bootstrap */
  .list-group-item {
    padding: 0;
    border: none;
    display: inline-flex;
    background-color: transparent;
  }
  .card {
    width: 100%;
    margin-bottom: 1.0rem;
  }

  .form-container {
    margin-bottom: 1.0rem;
  }

  /* pagination */
  .btn {
    font-size: 12px;
    margin-top: 5px;
  }
  .btn-number {
    border: none;
    background-color: transparent;
    cursor: pointer;
    font-size: 0.75em;
  }
  .btn-prev, .btn-next {
    background-color: transparent;

    &:hover {
      background-color: transparent;
    }
  }
  .selected {
    background-color: darken(lightgray, 13%);
  }
  .clicked {
    color: #0060ff;
  }


</style>
